
export default {
  name: 'KorzinkaGoIcon'
}
